<template>
  <div class="news">
    <div class="box2">
      <div class="flex-sp top">
        <ul class="flex flex1">
          <router-link tag="li" to="/news/company">公司新闻</router-link>
          <router-link tag="li" to="/news/product">产品动态</router-link>
          <router-link tag="li" to="/news/bazaar" style="display: none;">市场活动</router-link>
          <router-link tag="li" to="/news/world">恒生世界</router-link>
        </ul>
        <!-- <el-input class="inpt" placeholder="搜索相关资讯" v-model="keyword" @change="search"></el-input> -->
      </div>
      <div class="content">
        <keep-alive v-if="$route.meta.cache">
          <router-view></router-view>
        </keep-alive>
        <router-view v-else></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: "",
    };
  },
  mounted() {
  },
  methods: {
    search() {
      // this.$router.push({path:'/',query:{kw:this.keyword}})
    },
    // getdata(){
    //   this.$fetch({
    //     url:"index.php/news/cpdt",
    //     type:"post",
    //     data:this.$qs.stringify({keyword:this.keyword})
    //   }).then((res)=>{
    //     console.log(res,"55555555555555");
    //   })
    // }
  },
};
</script>

<style scoped>
.box2 .top {
  width: 100%;
  margin: 24px auto;
}
.box2 .top ul{
  display: flex;
  justify-content: space-between;
  padding: 0 47px;
}
.box2 .flex1 li {
  font-size: 28px;
  font-weight: 400;
  color: #333333;
}
.router-link-active {
  color: #396aff!important;
}
</style>